import { Component, OnInit, Input } from '@angular/core';
import { IChange } from '../../shared/change';

@Component({
  selector: 'app-db-grid',
  templateUrl: './db-grid.component.html',
  styleUrls: ['./db-grid.component.css']
})
export class DbGridComponent implements OnInit {

  @Input() changes: IChange[];

  constructor() { }

  ngOnInit() {
  }

}
